import { Amplify } from "aws-amplify";
import { livenessConfig } from "./regionConfig";

export function configureAmplify() {
  // Reads the region resolved from the URL rather than a single baked-in pool,
  // so one deployment serves both regions. App.tsx surfaces a proper error when
  // the active region's triplet is missing; the non-null assertions here just
  // keep Amplify's types happy on that already-failing path.
  Amplify.configure({
    aws_project_region: livenessConfig.awsRegion!,
    Auth: {
      Cognito: {
        identityPoolId: livenessConfig.identityPoolId!,
        allowGuestAccess: true,
      },
    },
  });
}
